import { XIcon } from 'lucide-react';
import { useState } from 'react';

interface PromotionalBannerProps {
  message: string;
  actionComponent?: React.ReactNode;
  dismissible?: boolean;
  textSize?: string;
}

export default function PromotionalBanner({ 
  message, 
  actionComponent, 
  dismissible = true,
  textSize = "lg"  // Default to lg, can be 'sm', 'base', 'lg', 'xl', '2xl'
}: PromotionalBannerProps) {
  const [isBannerVisible, setIsBannerVisible] = useState(true);

  if (!isBannerVisible) {
    return null;
  }

  // Create class based on the provided text size
  let textSizeClass = "";
  switch(textSize) {
    case "sm": textSizeClass = "text-sm"; break;
    case "base": textSizeClass = "text-base"; break;
    case "lg": textSizeClass = "text-lg"; break;
    case "xl": textSizeClass = "text-xl"; break;
    case "2xl": textSizeClass = "text-2xl"; break;
    default: textSizeClass = "text-lg";
  }
  
  return (
    <div className={`bg-black py-3 text-white flex text-center relative items-center justify-center ${textSizeClass}`}>
      <p className="font-normal">
        {message}
        {actionComponent}
      </p>
      {dismissible && (
        <button
          onClick={() => setIsBannerVisible(false)}
          className="absolute right-2 hover:bg-white/20 p-1 rounded-full transition-colors"
          aria-label="Close banner"
        >
          <XIcon size={16} strokeWidth={2.5} className="text-white" />
        </button>
      )}
    </div>
  );
} 